export default "__VITE_ASSET__C3edlYHE__"